export const  storageAdminsAvatarsPath = {
  path: "admins_avatars"
};
